"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var reactstrap_1 = require("reactstrap");
require("./NavMenu.css");
var NavMenu = /** @class */ (function (_super) {
    __extends(NavMenu, _super);
    function NavMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState({
                isOpen: !_this.state.isOpen
            });
        };
        _this.state = {
            isOpen: false,
            version: '',
            isHideAlert: false
        };
        return _this;
    }
    NavMenu.prototype.componentDidMount = function () {
        var _this = this;
        fetch("/v1/version")
            .then(function (res) { return res.json(); })
            .then(function (result) {
            _this.setState({
                version: result.message
            });
        }, function (error) {
        });
    };
    NavMenu.prototype.render = function () {
        var showAlert = this.state.isHideAlert;
        console.log(showAlert);
        return (React.createElement("header", null,
            React.createElement(reactstrap_1.Navbar, { className: "navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3", light: true },
                React.createElement(reactstrap_1.Container, null,
                    React.createElement(reactstrap_1.NavbarBrand, { tag: react_router_dom_1.Link, to: "/" },
                        "Focusone API Gateway Reference",
                        React.createElement("span", { style: { fontSize: '8pt', paddingLeft: '5px' } },
                            "V ",
                            this.state.version)),
                    React.createElement(reactstrap_1.NavbarToggler, { onClick: this.toggle, className: "mr-2" }),
                    React.createElement(reactstrap_1.Collapse, { className: "d-sm-inline-flex flex-sm-row-reverse", isOpen: this.state.isOpen, navbar: true },
                        React.createElement("ul", { className: "navbar-nav flex-grow" },
                            React.createElement(reactstrap_1.NavItem, null,
                                React.createElement("a", { target: "_blank", className: "text-dark nav-link", href: "https://gitlab.com/sonarinno/a-gape-cookbook/-/wikis/Focusone-API-Gateway" }, "How To")),
                            React.createElement(reactstrap_1.NavItem, null,
                                React.createElement("a", { target: "_blank", className: "text-dark nav-link", href: "https://documenter.getpostman.com/view/4063421/TVYQ1EGi" }, "API Document")),
                            React.createElement(reactstrap_1.NavItem, null,
                                React.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, className: "text-dark", to: "/logout" }, "Sign Out"))))))));
    };
    return NavMenu;
}(React.PureComponent));
exports.default = NavMenu;
//# sourceMappingURL=NavMenu.js.map